import React from 'react'
import './ece.css'

function ECE() {
    return (
        <div>
            <div className='ECE-card'>
            <div className='flip-card-ECE'>
                <div className='flip-card-inner-ECE'>
                    <div className='flip-card-front-ECE'>
                    <br/>
                        <h1>
                            Semiconductor Devices and Circuits
                        </h1>
                    </div>
                    <div class="flip-card-back-ECE">
                        <h3>
                            <a href='https://youtube.com/playlist?list=PLBlnK6fEyqRiw-GZRqfnlVIBz9dxrqHJS'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PL0n2jBUgUVhvsXil-D-V8LvNX6X5K00bL'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://easyengineering.net/semiconductor-device-fundamentals-by-pierret/'>Semiconductor Device Fundamentals</a>
                            <br/>
                            <a href='https://easyengineering.net/semiconductor-physics-and-devices-by-donald-neamen-book/'>Donald Neamen Semiconductor Physics</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-ECE'>
                <div className='flip-card-inner-ECE'>
                    <div className='flip-card-front-ECE'>
                        <h1>
                        <br/>
                            Digital Logic and Design
                        </h1>
                    </div>
                    <div class="flip-card-back-ECE">
                        <h3>
                        <br/>
                            <a href='https://youtube.com/playlist?list=PLBlnK6fEyqRjMH3mWf6kwqiTbT798eAOm'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PLWPirh4EWFpHk70zwYoHu87uVsCC8E2S-'>Video Resource 2</a>
                        </h3>
                        <h3>
                        <a href='https://easyengineering.net/digital-logic-and-computer-design-by-morris-mano/'>Digital Logic Design Textbook by Morris Mano</a>
                            <br/>
                            <a href='https://www.academia.edu/31294604/Digital_Logic_Design'>Digital Logic Design</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-ECE'>
                <div className='flip-card-inner-ECE'>
                    <div className='flip-card-front-ECE'>
                    <br/>
                        <h1>
                            Microcontroller and Microprocessor
                        </h1>
                    </div>
                    <div class="flip-card-back-ECE">
                        <h3>
                        
                            <a href='https://youtube.com/playlist?list=PLrjkTql3jnm8HbdMwBYIMAd3UdstWChFH'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PLWPirh4EWFpFDi8bggPYOiMLlD1D_bBPM'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://1lib.in/book/2768282/22260e'>The 8051 Microcontroller & Embedded Systems</a>
                            <br/>
                            <a href='https://1lib.in/book/510467/d179b0'>Introduction to Microprocessors and Microcontrollers</a>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
     
        </div>
    )
}

export default ECE
